
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The Social Media Share component allows users to add a personalised message to
  a link before sharing a specific page through their preferred social media
  network. It showcases the most popular ones, while the rest can be found in an
  overlay, by clicking the "other social networks" button.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/SocialMediaShare/Social%20media%20share.jpg" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/SocialMediaShare/Social%20media%20share%20-%20Mobile.jpg 598w, https://inno-ecl.s3.amazonaws.com/media/images/EC/SocialMediaShare/Social%20media%20share.jpg 734w" alt="Anatomy of social media share" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Short explanation of the purpose of the buttons`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Social media icon`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Link to Social Media`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the social media network`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`When more than 4-6 social networks are used, the button will open a pop-up where more social networks can be found`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`maintain the same order`}</strong>{` for the social media buttons`}</li>
      <li parentName="ul"><strong parentName="li">{`maintain the same colours`}</strong>{` for the social logo as the original`}</li>
      <li parentName="ul"><strong parentName="li">{`always display the icon and the name`}</strong>{` of the social media network`}</li>
      <li parentName="ul">{`always place the component at the bottom of the page`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't display more than 4-6 social media networks`}</strong>{`, use the "`}<em parentName="li">{`Other social networks`}</em>{`" link to add more`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`use when the content on a page may be important to users`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not use on navigation pages`}</li>
      <li parentName="ul">{`do not use if your organisation does not have personalised social media accounts`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <ul>
      <li parentName="ul">{`this functionality is provided by `}<a parentName="li" {...{
          "href": "https://webgate.ec.europa.eu/fpfis/wikis/pages/viewpage.action?spaceKey=webtools&title=Social+Media+Kit"
        }}>{`WebTools`}</a></li>
    </ul>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><Link to="/eu/components/social-media-follow/usage/" mdxType="Link">
  Social media follow
        </Link></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;